import {GameFlowController} from '../../components/game-flow-controller.js';
import {MenuPanels} from '../../models/UIModel.js';

export function goToMenu(targetMenu: MenuPanels, isPopup: boolean = false) {
    //   if (!ClickFocusManager.GetInstance().ProposeClick(gameObject.GetComponent<Collider>())) { return; }

    const gameFlow = GameFlowController.instance;
    if (gameFlow.canChangeMenu) {
        if (isPopup) {
            // if (!gameFlow.popupShowing)
            // {
            //     gameFlow.pushPopupMenu(targetMenu);
            // }
        } else {
            gameFlow.pushMenu(targetMenu);
        }
    }
}
